export default "/images/vendor/flag-icon-css/flags/1x1/om.svg?09e65f88432f6b938338e8d055807259";